import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";

import { Navigate, NavLink } from "react-router-dom";
import { useAccountStore } from "@/stores/account.store";
import AuthLayout from "@/layout/auth.layout";
import HekaLoader from "@/assets/heka-loader.svg?react";

export function LoginPage() {
  const { accountSnapshot, accountProxy } = useAccountStore();

  return (
    <AuthLayout>
      <Card className="max-w-xl mx-auto">
        <CardHeader>
          <CardTitle className="text-xl">
            Sign in to your organization
          </CardTitle>
          <CardDescription>Sign in using our SSO</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="grid gap-4">
            {accountSnapshot.isSigning && (
              <Button className="w-full" disabled>
                <HekaLoader className="max-h-full [--stroke:black]" />
              </Button>
            )}
            {!accountSnapshot.isLogged && (
              <div>
                <Button
                  onClick={() => {
                    accountProxy.login();
                  }}
                  className="w-full"
                >
                  Sign in with Heka
                </Button>
              </div>
            )}
            {accountSnapshot.isLogged && <Navigate to="/" />}
          </div>
          <div className="mt-4 text-sm text-center">
            You don't have any account?{" "}
            <NavLink to="/register">Sign-up</NavLink>
          </div>
        </CardContent>
      </Card>
    </AuthLayout>
  );
}

export default LoginPage;
